import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { HelmetProvider } from 'react-helmet-async';
import useGaPageTracker from './utils/useGaPageTracker';

// Pages
import Home from './v2/pages/Home';
import About from './v2/pages/About';
import Services from './v2/pages/Services';
import ServiceDetail from './v2/pages/ServiceDetail';
import Portfolio from './v2/pages/Portfolio';
import Contact from './v2/pages/Contact';
import Blog from './v2/pages/Blog';
import BlogPost from './v2/pages/BlogPost';
import NotFound from './v2/pages/NotFound';

// Components
import ScrollToTop from './components/ScrollToTop';
import V2Layout from './v2/components/V2Layout';

// Styles
import './App.css';
import './v2/styles/v2.css';

// Old /v2 preview URLs now live at the site root — send visitors there.
const LegacyV2Redirect = () => {
  const location = useLocation();
  const target = location.pathname.replace(/^\/v2/, '') || '/';
  return <Navigate to={target} replace />;
};

function App() {
  useGaPageTracker();

  return (
    <HelmetProvider>
      <ScrollToTop />
      <V2Layout>
        <AnimatePresence mode="wait">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/v2/*" element={<LegacyV2Redirect />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AnimatePresence>
      </V2Layout>
    </HelmetProvider>
  );
}

export default App;
